export default "__VITE_ASSET__BKD6Wi30__"